import React, { Fragment, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Auth from "../../auth/Auth";
import { http } from "../../helpers/http";
import { useDispatch, useSelector } from "react-redux";
import uuid from "uuid";
import {
  addCartItem,
  updateAciModal,
  updateCartLoader,
  updateEditData,
  updateSelectedItem,
} from "../../redux/actions/cartActions";
import { toast } from "react-toastify";
import { updateOnboardingState } from "../../redux/actions/authActions";
import ReplaceCartItems from "./ReplaceCartItems";
import { CART, PRICE_SYMBOL } from "../../eums/messages";
import { clearTipAdditionalInfo, getCartData } from "../../helpers/help";
import moment from "moment";

function AddCartItem(props) {
  const { outletId } = props;
  const cartItems = useSelector((state) => state.cart.cartItems);
  const selectedItem = useSelector((state) => state.cart.selectedItem);
  const aciModal = useSelector((state) => state.cart.aciModal);
  const editData = useSelector((state) => state.cart.editData);
  const cartOutletId = useSelector(
    (state) => state.cart.viewCartData.dishes?.outletDetails.outletId
  );
  const viewCartData = useSelector((state) => state.cart.viewCartData.dishes)
  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState(1);
  const [customisation, setCustomisation] = useState([]);
  const [calculativePrice, setCalculativePrice] = useState(0);
  const [rciModal, setRciModal] = useState(false);
  const [instructions, setInstructions] = useState("");
  const [notes, setNotes] = useState("")
  const ifDifferentOutlet = cartOutletId ? cartOutletId !== outletId : false;
  const isEditMode = !!Object.keys(editData).length;

  useEffect(() => {
    if (isEditMode) {
      setInstructions(editData.instructions);
      setQuantity(editData.quantity);
      dispatch(updateSelectedItem(editData.selectedItemData));
      dispatch(updateAciModal(true));
    }
  }, [editData]);

  useEffect(() => {
    setCalculativePrice(selectedItem.price);
  }, [selectedItem.price]);

  useEffect(() => {
    //reset the values upon modal close
    if (!aciModal) {
      setCalculativePrice(selectedItem.price);
      setQuantity(1);
      setCustomisation([]);
      setInstructions("");
      dispatch(updateEditData({}));
    }
  }, [aciModal]);

  useEffect(() => {
    setTotalPrice();
  }, [quantity]);

  useEffect(() => {
    setTotalPrice();
  }, [customisation]);

  useEffect(() => {
    if (Object.keys(selectedItem).length && selectedItem?.dishCustomisation) {
      const selectedAddOns = [];
      selectedItem.dishCustomisation.forEach((dishCustomisationItem) => {
        dishCustomisationItem.customizableDishItems.forEach(
          (customizableDish) => {
            //only add those customisations which isSelected 1.
            customizableDish.isSelected &&
              selectedAddOns.push(customizableDish);
          }
        );
      });
      setCustomisation(selectedAddOns);
    }
  }, [selectedItem]);

  const setTotalPrice = () => {
    if (!!selectedItem.price) {
      let addOnPrice = 0;
      customisation.forEach((item) => (addOnPrice = addOnPrice + item.stock_status === 1 ? 0 : item.Price));
      // customisation.forEach((item) => {
      //   addOnPrice += item.stock_status === 1 ? 0 : item.Price;
      // });

      // customisation.forEach((item) => (addOnPrice = addOnPrice + item.Price))

      const result = (+selectedItem.price + addOnPrice) * quantity;
      setCalculativePrice((Math.round(result * 100) / 100).toFixed(2));
    }
  };

  const addOnHandler = (event, data, customizableId) => {
    if (event.target.checked) {
      if (event.target.name === "single") {
        customisation.find((zzz, ind) => {
          if (zzz.customisationCategoryId === customizableId) {
            customisation.splice(ind, 1);
            return true;
          }
        });
      }
      customisation.push(data);
      setCustomisation([...customisation]);
    } else {
      setCustomisation((previousState) => {
        const newState = [...previousState];
        newState.find((item, index) => {
          if (item.elementId === data.elementId) {
            newState.splice(index, 1);
            return true;
          }
          return false;
        });
        return newState;
      });
    }
  };

  const checkItemSame = () => {
    let foundItem = false;
    if (cartItems) {
      foundItem = cartItems.filter(
        (dishItem) => dishItem.dishId === selectedItem.dishId
      );

      if (foundItem) {
        foundItem = foundItem.find((qwe) => {
          //check previous item's customization is equal to new item's customization
          //check customisation length
          if (
            instructions !== qwe.spl_instruction ||
            customisation.length !== qwe.customisation.length
          ) {
            return false;
          }
          const result = customisation.every((newCustomisation) => {
            const isCustomisationExist = qwe.customisation.some(
              (cId) => cId.dishCustomisationId === newCustomisation.elementId
            );
            return isCustomisationExist;
          });

          return result;
        });
      }
    }
    return foundItem;
  };

  const updateCartItem = (payload) => {
    dispatch(updateCartLoader(true));
    http(
      {
        method: "POST",
        url: `updateCart`,
        isSecure: true,
        body: payload,
      },
      (res) => {
        if (res.error === "false") {
          getCartData();
          toast.success(CART.ITEM_UPDATED);
        }
      }
    );
  };

  const formattedCustomisation = () =>
    customisation.map((item) => ({
      dishCustomisationId: item.elementId,
    }));

  const addItemToCart = () => {
    dispatch(updateAciModal(false));
    if (isEditMode) {
      const apiData = {
        cartId: selectedItem.cartId,
        udId: Auth.userInfo()?.udId,
        outletId: cartOutletId,
        quantity,
        spl_instruction: instructions,
        os: "web",
        customisationId: JSON.stringify(formattedCustomisation()),
      };
      updateCartItem(apiData);

      //Return here if only update the item
      return;
    }

    const isItemSame = checkItemSame();
    if (isItemSame) {
      const apiData = {
        cartId: isItemSame.cartId,
        udId: Auth.userInfo()?.udId,
        outletId: cartOutletId,
        quantity: isItemSame.quantity + quantity,
        spl_instruction: isItemSame.spl_instruction,
        os: "web",
        customisationId: JSON.stringify(isItemSame.customisation),
      };
      updateCartItem(apiData);
    } else {
      const newCartItem = {
        quantity,
        customisation: formattedCustomisation(),
        dishId: selectedItem.dishId,
        uuId: uuid.v4().toUpperCase(),
        os: "web",
        spl_instruction: instructions,
      };

      const bodyData = {
        order_type: "Take Out",
        spl_instruction: instructions,
        outletId,
        udId: Auth.userInfo().udId,
        uuId: uuid.v4().toUpperCase(),
        os: "web",
        dishes: JSON.stringify(
          ifDifferentOutlet ? [newCartItem] : [...cartItems, newCartItem]
        ),
      };

      dispatch(updateCartLoader(true));
      http(
        {
          method: "POST",
          url: `addToCart`,
          isSecure: true,
          body: bodyData,
        },
        (res) => {
          if (res.error === "false") {
            toast.success(CART.ITEM_ADDED);
            dispatch(addCartItem(newCartItem));
            ifDifferentOutlet && clearTipAdditionalInfo();
          }
          if (res.error === "true") {

            toast.error(res.errorMessage);
            dispatch(updateCartLoader(false));
          }
        },
      );
    }
  };



  const submitHandler = () => {
    if (!Auth.isUserAuthenticated()) {
      dispatch(updateAciModal(false));
      dispatch(updateOnboardingState("login"));
      return;
    }
    if (selectedItem.dishCustomisation.length > 0) {
      if (selectedItem.isCustomizable === 0 || customisation.length > 0) {
        addItemToCart();
      } else {
        toast.error("Please select at least one item.");
      }
      return;
    }

    if (!isEditMode && ifDifferentOutlet) {
      setRciModal(true);
    } else {
      addItemToCart();
    }
  };

  const isItemSelected = (customizableDishItem) => {
    return customisation.some(
      (bbb) => bbb.elementId === customizableDishItem.elementId

    );

  };

  const showAddOn = (list, isSelected, cType) => {
    //handle multiple case
    if (cType === "multiple") return true;

    //handle single case
    const isNoOneSelected = list.every((item) => !item.isSelected);
    if (isNoOneSelected) return true;
    else return isSelected;
  };



  return (
    <>
      <Modal
        show={aciModal}
        onHide={() => dispatch(updateAciModal(false))}
        centered
        className="center-close-icon add-cart-modal"
        style={{ zIndex: 1050 }}
      >
        <Modal.Header closeButton></Modal.Header>
        <div className="bodyModal">
          <h6 className="head7 mb-1 blackC text-break">
            {selectedItem.dishName}
            {selectedItem.isVeg === 1 ? (
              <img
                src="./assets/img/vegi_icon.svg"
                alt="veg img"
                className="ms-2"
              />
            ) : ""
              // <img src="./assets/img/nv.svg" alt="veg img" className="ms-2" />
            }
            {/* <img
              src="./assets/img/vegi_icon.svg"
              alt="veg img"
              className="ms-2"
            /> */}
          </h6>
          <h6 className="head6 mb-1 blackC">{selectedItem.displayPrice}</h6>
          <p className="txt text-break">{selectedItem.description}</p>
          {!!selectedItem.isCustomisation &&
            selectedItem.dishCustomisation.some(
              (item) => item.customizableDishItems.length
            ) && (
              <>
                <div className="line-content-middle my-3"></div>
                <h6 className="head5  mb-2 blackC">Add On</h6>

                <div className="customisation-scrollbar">
                  {/* map on single and mulitple category */}
                  {(selectedItem.dishCustomisation || []).map((item) => (
                    <div key={item.customizableId} className="mt-1">
                      <b className="text-break">{item.customizableName}</b>
                      {item.customizableDishItems.map(
                        (customizableDishItem, index) => (
                          // add on item
                          <Fragment
                            key={`customizableDishItem-${customizableDishItem.elementId}`}
                          >
                            {showAddOn(
                              item.customizableDishItems,
                              // !!customizableDishItem.isSelected,
                              item.customizableType
                            ) && (
                                <div className="d-flex align-items-center justify-content-between mb-1 ps-2">
                                  <p className="txt blackC mb-0 text-break me-1">
                                    {customizableDishItem.elementName}
                                  </p>
                                  {/* {
                                    customizableDishItem.stock_status == 1 ? <span className="out_stock_customizable">Out of Stock</span> : */}
                                  <p className="txt blackC mb-0 d-flex ms-1">
                                    {customizableDishItem.displayPrice}
                                    <span className="radio-group ms-2">
                                      {item.customizableType === "single" ? (
                                        <label className="checkbox-btn">
                                          <input
                                            type="checkbox"
                                            name="single"
                                            checked={isItemSelected(
                                              customizableDishItem
                                            )}
                                            // disabled={
                                            //   customizableDishItem.isSelected
                                            // }
                                            onChange={(event) =>
                                              addOnHandler(
                                                event,
                                                customizableDishItem,
                                                item.customizableId
                                              )
                                            }
                                          />
                                          <span className="checkmark"></span>
                                        </label>
                                      ) : (
                                        <label className="check-container ms-2">
                                          <input
                                            type="checkbox"
                                            name="multiple"
                                            checked={isItemSelected(
                                              customizableDishItem
                                            )}
                                            onChange={(event) =>
                                              addOnHandler(
                                                event,
                                                customizableDishItem,
                                                item.customizableId
                                              )
                                            }
                                            className="d-none"
                                          />
                                          <span className="checkmark"></span>
                                        </label>
                                      )}
                                    </span>
                                  </p>
                                  {/* } */}


                                </div>
                              )}
                          </Fragment>
                        )
                      )}
                      {/* <div className="my-2">
                        <input
                          type="text"
                          placeholder="Type notes..."
                          className="input_control"
                          onChange={(e) => setNotes(e.target.value)}
                          value={notes}
                        />
                      </div> */}
                    </div>
                  ))}
                </div>
              </>
            )}

          <div className="line-content-middle my-3"></div>
          <h6 className="head6 mb-2 blackC">Notes</h6>
          <div className="modaltextarea">
            <textarea
              value={instructions}
              className="textarea"
              onChange={(event) => setInstructions(event.target.value)}
            />
          </div>
          {!!selectedItem.stock_status ? (
            <div className="out-of-stock-button mt-4">Out of Stock</div>
          ) : selectedItem.dishavailable ? (
            <div className={`footerM mt-4 d-flex align-items-center`}>
              <div className={`add_num me-3`}>
                <button
                  className="btnAdd_pr"
                  onClick={() => {
                    if (quantity !== 1) {
                      setQuantity((ps) => {
                        return ps - 1;
                      });
                    }
                  }}
                >
                  -
                </button>
                <div>{quantity}</div>
                <button
                  className="btnAdd_pr"
                  onClick={() =>
                    setQuantity((ps) => {
                      return ps + 1;
                    })
                  }
                >
                  +
                </button>
              </div>
              <button
                id="add-item-btn-14214"
                className="cusbtn w-100"
                onClick={submitHandler}
                disabled={selectedItem.stock_status}
              >
                {isEditMode ? "Update Item" : "Add Item"}   {" "}
                <span>
                  {PRICE_SYMBOL}
                  {calculativePrice}
                </span>
              </button>
            </div>
          ) : (
            <div className="mt-4 d-flex justify-content-center">
              Dish is available from{" "}
              {moment(selectedItem.availableFrom, " H:mm").format(" H:mm")} to
              {moment(selectedItem.availableTo, " H:mm").format(" H:mm")}
            </div>
          )}
        </div>
      </Modal>
      <ReplaceCartItems
        rciModal={rciModal}
        setRciModal={setRciModal}
        addItemToCart={addItemToCart}
      />
    </>
  );
}

export default AddCartItem;
